/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
// import { Nav, Tab } from "react-bootstrap";
// import SVG from "react-inlinesvg";
// import { toAbsoluteUrl } from "../../../_helpers";
import * as _enter from "../../../../app/pages/CatalogClients/operations"
import * as crud from "../../../../app/pages/Campaign/operations"

import { useSelector } from "react-redux";
import {

  Badge,
  Spinner
} from "react-bootstrap";
import moment from "moment"
function diff_minutes(dt2, dt1) {
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.round(diff)

}

export function AdvanceTablesWidget2({ className, queryng, campaign, posv }) {
  const { user } = useSelector(state => state.auth);
  const current = user.uid ? user : user.payload

  const [enter, setEnterprise] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      const [enterprise_query] = await Promise.all([_enter.getClient(current.company_id)])
      const enterprise = enterprise_query.data.payload
      setEnterprise(enterprise)
    }
    fetchData()
  }, [current.company_id])
  const start_future = moment(`${campaign.start_date}`).toDate()
  const end_future = moment(`${campaign.end_date} `).toDate()
  const today = moment().toDate()

  const minuts_start = diff_minutes(start_future, today)
  const minuts_end = diff_minutes(end_future, today)
  const state = campaign.mode === "draft" ? "DRAFT" : minuts_start > 0 ? "Waiting for start" : minuts_end > 0 ? "On Going" : "Done"

  const childs = campaign.childs ?? []
  const variants = {
    "DRAFT": "danger",
    "Waiting for start": "primary",
    "On Going": "warning",
    "Done": "success"
  }
  const round = [...new Set(childs.map(child => child.wave))].sort().pop()

  if (queryng) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }
  if (!campaign.uid) {
    return (
      <div className={`card card-custom ${className} w-100`}>
        {/* Head */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              Last Campaign
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
            </span>
          </h3>
          <div className="card-toolbar">

          </div>
        </div>
        {/* Body */}
        <div className="card-body pt-3 pb-0">
          <div>
            <div className="d-flex w-100 justify-content-center">
              <img src={enter.logo_url} alt="nothing" width="300px" />
            </div>
            <div className="d-flex w-100 justify-content-center">
              <p>No campaigns</p>
            </div>
          </div>
        </div>
      </div>

    )
  }
  return (
    <div className={`card card-custom ${className} w-100`}>
      {/* Head */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label font-weight-bolder text-dark">
            Last Campaign
          </span>
          <span className="text-muted mt-3 font-weight-bold font-size-sm">
          </span>
        </h3>
        <div className="card-toolbar">

        </div>
      </div>
      {/* Body */}

      <div className="m-2 rounded-xl">
        <div className="row">
          <div className="col-12">

            <div className="row p-10 pl-1">
              <div className="col-3">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-store fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">
                    <label>
                      <strong>
                        Campaign Name
                      </strong>
                    </label>
                    <h4>{campaign.name}</h4>
                  </div>
                </div>
              </div>
              <div className="col-2">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-globe-americas fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">

                    <label>
                      <strong>
                        State
                      </strong>
                    </label>
                    <h4 >{campaign.state}</h4>
                  </div>
                </div>

              </div>

              <div className="col-2">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-calendar-check fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">
                    <label>
                      <strong>
                        Start Date
                      </strong>
                    </label>
                    <h4 >{moment(campaign.start_date).format("MMMM/DD/YY")}</h4>
                  </div>
                </div>
              </div>
              <div className="col-2">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-calendar-times fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">
                    <label>
                      <strong>
                        End Date
                      </strong>
                    </label>
                    <h4 >{moment(campaign.end_date).format("MMMM/DD/YY")}</h4>
                  </div>
                </div>

              </div>
              <div className="col-3">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    {state === "On Going" ? <i class="fas fa-unlock-alt fa-3x" style={{ color: "#5E78FF" }}></i> : <i class="fas fa-lock fa-3x" style={{ color: "#5E78FF" }}></i>}
                  </div>
                  <div className="col-md-9 col-lg-9">
                    <label>
                      <strong>
                        Campaign Status
                      </strong>
                    </label>
                    <h4> <Badge variant={variants[state]}>{state}</Badge></h4>
                  </div>
                </div>


              </div>
            </div>
            <div className="row p-10 pl-1">
              <div className="col-3">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-info-circle fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">
                    <label>
                      <strong>
                        Description
                      </strong>
                    </label>
                    <h4 >{campaign.description}</h4>
                  </div>
                </div>

              </div>

              <div className="col-2">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-map-marked-alt fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">

                    <label>
                      <strong>
                        Locations
                      </strong>
                    </label>
                    <h4 >{campaign.pos?.length}</h4>
                  </div>
                </div>

              </div>
              <div className="col-2">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-flag-checkered fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">

                    <label>
                      <strong>
                        Visited Locations
                      </strong>
                    </label>
                    <h4 >{posv}</h4>
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-redo-alt fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">
                    <label>
                      <strong>
                        Rounds
                      </strong>
                    </label>
                    <h4 >{round}</h4>
                  </div>
                </div>
              </div>
              <div className="col-2">
                <div className="row">
                  <div className="col-md-3 col-lg-3 pt-1">
                    <i class="fas fa-briefcase fa-3x" style={{ color: "#5E78FF" }}></i>
                  </div>
                  <div className="col-md-9 col-lg-9">
                    <label>
                      <strong>
                        Campaign type
                      </strong>
                    </label>
                    <h3> {(campaign.type ?? "").toUpperCase()}</h3>
                  </div>
                </div>


              </div>
              <div className="col-3">
              </div>

            </div>

          </div>



        </div>

      </div>



    </div>
  );
}